import Select from "react-select";
import { Card, Form } from "react-bootstrap";
import { useState, useEffect } from "react";
import axios from "axios";

export default function DocumentItems({ documentType, documentItems, setDocumentItems, setTotals }) {
  const [products, setProducts] = useState([]);
  const [subTotal, setSubTotal] = useState(0);
  const [praAmount, setPraAmount] = useState(0);
  const [totalAmount, setTotalAmount] = useState(0);
  const [praPercent, setPraPercent] = useState(0);

  useEffect(() => {
    getProducts();
  }, []);

  useEffect(() => {
    calculateTotals();
  }, [documentItems, praPercent]);

  useEffect(() => {
    // Pass updated total values to the parent
    setTotals({ 
      total: totalAmount, 
      sub_total: subTotal, 
      pra_percent: praPercent 
    });
  }, [totalAmount, subTotal, praPercent]);

  const getProducts = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/admin/products`,
        {
          headers: {
            "Access-Token": localStorage.getItem("accessToken"),
          },
          params: {
            limit: 100,
            page: 1,
            sort_by: "displayable",
            sort_order: "desc",
          },
        }
      );
      setProducts(response.data.products);
    } catch {
      console.error("Failed to fetch products.");
    }
  };

  const handleAddItem = () => {
    setDocumentItems([
      ...documentItems,
      {
        product_id: "",
        description: "",
        quantity: 1,
        price: 0,
        no_of_years: 1,
        discount: 0,
        total: 0,
      },
    ]);
  };

  const handleItemChange = (index, field, value) => {
    const updatedItems = documentItems.map((item, i) => {
      if (i === index) {
        const updatedItem = { ...item, [field]: value };

        // Auto-fill price when product is selected
        if (field === "product_id") {
          const selectedProduct = products.find(
            (product) => product.id.toString() === value
          );
          updatedItem.price = selectedProduct ? selectedProduct.price : 0;
        }

        // Recalculate total with discount
        const quantity = parseInt(updatedItem.quantity) || 1;
        const no_of_years = parseInt(updatedItem.no_of_years) || 1;
        const price = parseFloat(updatedItem.price) || 0;
        const discount = parseFloat(updatedItem.discount) || 0;

        if (quantity > 0 && price >= 0 && discount >= 0 && discount <= 100 && no_of_years > 0) {
          updatedItem.total = (quantity * price * no_of_years) * (1 - discount / 100);
        } else {
          updatedItem.total = 0;
        }

        return updatedItem;
      }
      return item;
    });

    setDocumentItems(updatedItems);
  };

  const handleRemoveItem = (index) => {
    setDocumentItems(documentItems.filter((_, i) => i !== index));
  };

  const calculateTotals = () => {
    const subTotalValue = documentItems.reduce(
      (sum, item) => sum + parseFloat(item.total || 0),
      0
    );
    const praValue = (subTotalValue * praPercent) / 100;
    const totalValue = subTotalValue + praValue;

    setSubTotal(subTotalValue);
    setPraAmount(praValue);
    setTotalAmount(totalValue);
  };

  return (
    <div>
      <div className="d-flex align-items-center gap-2 mb-3">
        <h5 className="m-0">Add Items</h5>
        <button
          type="button"
          className="btn btn-success btn-sm d-flex align-items-center justify-content-center"
          onClick={handleAddItem}
          style={{
            width: "30px",
            height: "30px",
            borderRadius: "30%",
            fontWeight: "bolder",
          }}
        >
          +
        </button>
      </div>

      {documentItems.map((item, index) => (
        <Card key={index} className="row mb-3 align-items-center">
          <Card.Header>
            <div className="d-flex align-items-center justify-content-between">
              <div className="col-auto">
                <h5>Item {index + 1}</h5>
              </div>
              <div className="col-auto">
                <p
                  className="m-0 cursor-pointer"
                  style={{ fontSize: "24px", fontWeight: "bold" }}
                  onClick={() => handleRemoveItem(index)}
                >
                  x
                </p>
              </div>
            </div>
          </Card.Header>

          <Card.Body>
            <div className="row">
              <div className="col-lg-2 col-md-4 col-sm-6">
                <label>Product</label>
                <select
                  required
                  className="form-control"
                  value={item.product_id}
                  onChange={(e) =>
                    handleItemChange(index, "product_id", e.target.value)
                  }
                >
                  <option value="">Select Product</option>
                  {products.map((product) =>
                    product.displayable ? (
                      <option key={product.id} value={product.id}>
                        {product.pid}
                      </option>
                    ) : null
                  )}
                </select>
              </div>
              <div className="col-lg-2 col-md-4 col-sm-6">
                <label>Description</label>
                <Form.Control
                  as="textarea"
                  rows={1}
                  value={item.description}
                  onChange={(e) => handleItemChange(index, "description", e.target.value)}
                  onInput={(e) => {
                    e.target.style.height = "auto";
                    e.target.style.height = `${e.target.scrollHeight}px`;
                  }}
                  style={{ overflow: "hidden", resize: "none" }}
                />
              </div>
              <div className="col-lg-1 col-md-4 col-sm-6">
                <label>Price</label>
                <input
                  type="number"
                  className="form-control"
                  value={item.price}
                  onChange={(e) =>
                    handleItemChange(index, "price", e.target.value)
                  }
                  placeholder="Price"
                />
              </div>
              <div className="col-lg-1 col-md-4 col-sm-6">
                <label>Quantity</label>
                <input
                  type="number"
                  className="form-control"
                  value={item.quantity}
                  onChange={(e) =>
                    handleItemChange(index, "quantity", e.target.value)
                  }
                  placeholder="Quantity"
                />
              </div>
              <div className="col-lg-2 col-md-4 col-sm-6">
                <label>No of years</label>
                <input
                  type="number"
                  className="form-control"
                  value={item.no_of_years}
                  onChange={(e) =>
                    handleItemChange(index, "no_of_years", e.target.value)
                  }
                  placeholder="No of Years"
                />
              </div>
              <div className="col-lg-2 col-md-4 col-sm-6">
                <label>Discount (%)</label>
                <input
                  type="number"
                  className="form-control"
                  value={item.discount}
                  onChange={(e) =>
                    handleItemChange(index, "discount", e.target.value)
                  }
                  placeholder="Discount (%)"
                  min="0"
                  max="100"
                />
              </div>
              <div className="col-lg-2 col-md-4 col-sm-6">
                <label>Total</label>
                <input
                  type="number"
                  className="form-control"
                  value={item.total.toFixed(2)}
                  readOnly
                />
              </div>
            </div>
          </Card.Body>
        </Card>
      ))}

      <div className="mt-4">
        <div className="row">
          <div className="col-lg-4 col-md-6">
            <label><strong>Sub-Total:</strong></label>
            <input type="number" className="form-control" value={subTotal.toFixed(2)} readOnly />
          </div>
          <div className="col-lg-4 col-md-6">

            <label><strong>{documentType == "Quotation" ? "PRA":"Sales tax"}(%):</strong></label>
            <input type="number" className="form-control" value={praPercent} onChange={(e) => setPraPercent(e.target.value)} />
          </div>
          <div className="col-lg-4 col-md-6">
            <label><strong>Total Amount:</strong></label>
            <input type="number" className="form-control" value={totalAmount.toFixed(2)} readOnly />
          </div>
        </div>
      </div>
    </div>
  );
}
